import { prefix } from './actions';

export const loading = state => state[prefix].loading;

export const rate = state => state[prefix].rate;

export const history = state => state[prefix].history;
